/**
 * Created by dv on 9/7/2017.
 */
import {
  SetCollectionMetadataForWebClientQuery,
  SetCollectionMetadataMessage,
  ValueList
} from "../../../autogenerated/ZoomBridge";
import Hashmap from "./../../../protocol/HashMap";

export default class SetCollectionMetadata {
  /**
   *
   * Creates a new object of the class to set the collection metadata
   * @param collectionId is the collection id for which the metadata is to be saved.
   */
  constructor(collectionId) {
    this._collectionId = collectionId;
    this._collectionMetadata = new Hashmap();
  }

  /**
   * Sets the append field. Append field by default value is false, which is replace the existing values <br>
   *  with the new values passed.
   * @param append if true means the metadata values are to be appended with the existing values
   * @return {SetCollectionMetadata}
   */
  setAppend(append) {
    this._append = append;
    return this;
  }

  /**
   * Sets the metadata key,value to the collection metadata map.
   * @param key is the metadata property name
   * @param value is the metadata value to be set.
   * @return {SetCollectionMetadata}
   */
  setMetadata(key, value) {
    if (!this._collectionMetadata || !this._collectionMetadata.containsKey(key)) {
      let valueList = new ValueList();
      valueList.setValues([]);
      this._collectionMetadata.put(key, valueList);
    }
    /**
     * @type {ValueList}
     */
    let valueList = this._collectionMetadata.get(key);
    valueList.getValues().push(value);
    return this;
  }

  run() {
    const message = new SetCollectionMetadataMessage();
    message.setCollectionId(this._collectionId);
    message.setAppend(this._append);
    message.setCollectionMetadata(this._collectionMetadata);
    const query = new SetCollectionMetadataForWebClientQuery();
    query.message = message;
    return query.run();
  }
}
